import React from 'react'
import LotteryResultSectionHeader from '../LotteryResultSectionHeader'

/** Fallback section หวยรัฐบาล: ใช้เมื่อยังโหลดหรือไม่พบงวดหวยรัฐบาล (ไม่แสดงงวด static เก่า) */
const LotteryResultStaticGovernment: React.FC = () => (
  <div className="col-12 col-lg-6 px-1 mb-4">
    <LotteryResultSectionHeader
      title="หวยรัฐบาล"
      iconUrl="flag/th.png"
      drawLabel="ไม่พบข้อมูลงวด"
    />
    <div className="wrap-box p-2 pt-0 bgg-7 bdr-5">
      <div className="row mx--1">
        <div className="col-12 px--1 mt-2 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>รางวันที่ 1</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1 t-medium">
              <h4>รอผล</h4>
            </div>
          </div>
        </div>
        <div className="col-6 col-lg-3 px--1 mt-1 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>3ตัวบน</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h5>รอผล</h5>
            </div>
          </div>
        </div>
        <div className="col-6 col-lg-3 px--1 mt-1 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>2ตัวล่าง</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h5>รอผล</h5>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 px--1 mt-1 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>3ตัวล่าง</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h5>รอผล</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LotteryResultStaticGovernment
